import * as React from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch } from "../../store/hooks";
import { parseForDashboard } from "../../store/uiDataSlice";

export const SetupParsedLocation: React.FC = () => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();

  React.useEffect(() => {
    dispatch(parseForDashboard(pathname));
  }, [pathname]);

  return null;
};
